/**
 * @file CMS
 * @author yuanyaojia<yuanyaojia@baijia.com>
 * @date 2021-4-21
 */

import http from './http';
import constant from './constant';

/**
  * 通过channelCode获取首页显示的相关内容
  * url: /cms/getByChannelCode.json
  * 方法：POST
  */

export const getByChannelCode = params => http.post(constant.CMS.GET_BY_CHANNEL_CODE, params);

/**
  * 通过类别编码获取子类别
  * url: /cms/category/list.json
  * 方法：POST
  */

export const getCategoryList = params => http.post(constant.CMS.GET_CATEGORY_LIST, params);

/**
  * 通过文章id获取文章详情
  * url: /cms/getInfoById.json
  * 方法：POST
  */

export const getInfoById = params => http.post(constant.CMS.GET_INFO_BY_ID, params);

/**
  * 通过channelCode分页获取列表
  * url: /cms/getListByChannelCode.json
  * 方法：POST
  */

export const getListByChannelCode = params => http.post(constant.CMS.GET_LIST_BY_CHANNEL_CODE, params);

/**
  * 通过视频id获取视频播放链接
  * url: /cms/video/getVideoPlayUrl.json
  * 方法：POST
  */

export const getVideoPlayUrl = params => http.post(constant.CMS.GET_VIDEO_PLAY_URL, params);

/**
  * 新闻
  * url: /news/list.json
  * 方法：POST
  */

export const getRecentNews = params => http.post(constant.CMS.RECENT_NEWS, params);

/**
  * 新闻
  * url: /news/list.json
  * 方法：POST
  */

export const getNewsInfo = params => http.post(constant.CMS.NEWS_INFO, params);
